var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-label',{attrs:{"config":_vm.configTooltip}},[_c('v-tag',{attrs:{"config":_vm.tagConfig}}),_c('v-text',{attrs:{"config":_vm.textConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }